import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import { ensureReportAuth } from './reportAuth'

// Talent tags + relationship-map counts for the monthly/quarterly engaged pages.
// Replaces POST https://api2.happily.ai/api/gettalentandnetwork (PHP, being shut
// down). The function proxies to happily-schedule and scopes the request to the
// company of the caller's Firebase session (the report-viewer token here).
const TALENT_AND_NETWORK_URL = 'https://us-central1-people2-admin.cloudfunctions.net/legacyTalentAndNetwork'

export async function fetchTalentAndNetwork(body: { email: string; date: string; company: string }): Promise<any> {
  await ensureReportAuth()
  const user = firebase.auth().currentUser
  if (!user) {
    throw new Error('fetchTalentAndNetwork: not signed in')
  }
  const idToken = await user.getIdToken()
  return axios.post(TALENT_AND_NETWORK_URL, body, {
    headers: { Authorization: `Bearer ${idToken}` },
    timeout: 30000,
  })
}
